import {useContext} from 'react'
import {PlayerStatsContext} from '../context/PlayerStatsContext'
import {BackgroundMusicContext} from '../context/BackgroundMusicContext'
import gameStages from '../context/gameData/gameStagesData'

function useAuthentication() {
    const {localStorage} = window
    const player = useContext(PlayerStatsContext)
    const {userMutedBackground, toggleMuteBackground, stop} = useContext(BackgroundMusicContext)
    
    function logIn(userKey) {
        console.log('userKey: ' + userKey)
        return new Promise((resolve, reject) => {
            const loginDetails = {
                userKey: userKey,
                urlEndPoint: "/auth"
            }
    
            contactDatabase(loginDetails)
                .then((response) => {
                    console.log('API response', response)
                    if (!response.success) {
                        const localKey = localStorage.getItem('localKey')
                        player.setAuthorised(false)
                        localKey && localStorage.removeItem('localKey')
                        reject('there was an error')
                    } else if (response.success) {
                        if (response.data.activated_at === null) {
                            contactDatabase({
                                userKey: userKey,
                                urlEndPoint: '/activate',
                                activate: true
                            })
                        }
                        localStorage.setItem('localKey', userKey)
                        player.setDatabaseStage(response.data.stage)
                        player.setAuthorised(true)
                        resolve('/landing')
                    }
                }).catch((error) => {
                    console.error('there was an error')
                })
        })
    }
    
    function saveGame(location) {
        const localKey = localStorage.getItem('localKey')
        
        return new Promise((resolve, reject) => { 
            let newStats
            const { playerStats } = player
            if (location === 'office') {
                newStats = {
                    ...playerStats,
                    office: 'complete',
                    library: 'open',
                    laboratory: 'open',
                    fourJokers: 'open'
                }
            } else if (location === 'lastStand') {
                newStats = {
                    ...playerStats,
                    lastStand: 'complete',
                    machine: 'open'
                }
            } else {
                newStats = {
                    ...playerStats,
                    [location]: 'complete'
                }
            }

            if (
                newStats.library === 'complete' &&
                newStats.laboratory === 'complete' &&
                newStats.fourJokers === 'complete' &&
                newStats.lastStand === 'locked'
            ) { newStats.lastStand = 'open' }
            
            const newStatsArr = Object.values(newStats)
            newStatsArr.pop() // remove gameState from comparison
            let matchingIndex
            gameStages.forEach((stage, stageIndex) => {
                const stageArr = Object.values(stage)
                console.log(stageArr)
                stageArr.pop() // remove gameState from comparison
                if (stageArr.every((val, index) => val === newStatsArr[index])) {
                    matchingIndex = stageIndex
                }
            })
            player.setDatabaseStage(matchingIndex)

            const saveDetails = {
                userKey: localKey,
                urlEndPoint: "/update/stage",
                stage: matchingIndex
            }

            contactDatabase(saveDetails)
                .then(response => {
                    console.log("API Response", response)
                    if (!response.success) {
                        player.setAuthorised(false)
                        logOut()
                        reject('you are not logged in')
                    } else if (response.success) {
                        resolve(true)
                    }
                })
                .catch(error => {
                    console.error(error)
                    alert('there was an error saving your game')
                })
        })
    }
    
    function logOut() {
        !userMutedBackground ? toggleMuteBackground() : stop()
        localStorage.removeItem('localKey')
    }

    function contactDatabase(data) {
        return fetch('/.netlify/functions/dbUpdate', {
            body: JSON.stringify(data),
            method: 'POST'
        }).then(response => {
            return response.json()
        })
    }
    
    return {logIn, saveGame, logOut}
}

export default useAuthentication